













import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Department, departmentApis } from '../api';
import SearchTransfer from './SearchTransfer.vue';

@Component({ components: { SearchTransfer } })
export default class DepartmentTransfer extends Vue {
  @Prop({ required: true }) selected!: Array<any>;
  @Prop({ required: true }) moveIn!: (item: Department) => Promise<void>;
  @Prop({ required: true }) moveOut!: (item: Department) => Promise<void>;

  departments: Array<Department> = [];

  async mounted() {
    await this.searchDepartment('');
  }

  departmentTitle = (d: Department) => d.name;

  departmentTooltip(d: Department): string {
    if (d.parent) {
      return `${d.parent.name} / ${d.name}`;
    }
    return d.name;
  }

  searchDepartment(search: string) {
    return departmentApis.search(search).then(departments => (this.departments = departments));
  }
}
